import * as React from 'react'
import { cva } from 'class-variance-authority'
import { AlertCircle, CheckCircle2, Info, TriangleAlert } from 'lucide-react'

import { cn } from '@/lib/utils'

const alertVariants = cva(
  'relative flex w-full items-start gap-2.5 rounded-md border px-3.5 py-2.5 text-sm',
  {
    variants: {
      variant: {
        default: 'bg-card text-foreground',
        info: 'border-primary/20 bg-accent text-accent-foreground [&>svg]:text-primary',
        success: 'border-success/30 bg-success/10 text-success [&>svg]:text-success',
        warning: 'border-warning/40 bg-warning/10 text-[hsl(var(--warning))] [&>svg]:text-warning',
        error: 'border-destructive/30 bg-destructive/10 text-destructive [&>svg]:text-destructive',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

const iconForVariant = {
  default: Info,
  info: Info,
  success: CheckCircle2,
  warning: TriangleAlert,
  error: AlertCircle,
}

const Alert = React.forwardRef(({ className, variant = 'default', icon = true, children, ...props }, ref) => {
  const Icon = iconForVariant[variant] || Info
  return (
    <div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props}>
      {icon && <Icon className="mt-0.5 h-4 w-4 shrink-0" />}
      <div className="flex-1 leading-relaxed">{children}</div>
    </div>
  )
})
Alert.displayName = 'Alert'

export { Alert, alertVariants }
